import ListingVehicle from './listing-vehicle.container'

export default ListingVehicle
